export default "__VITE_ASSET__Dgq3uZi9__"